import { FC, ReactElement } from 'react'
import PerFlexRow from '../../FlexRow'
import PerText from '../../Text'
import { Colors, TShirtSize } from '../../../util/types'

export interface PerInfoBoxTileProps {
  heading: string
  headingColor?: Colors
  headingAlign?: 'left' | 'center' | 'right'
  contentAlign?: 'start' | 'center' | 'end' | 'space-between' | 'space-around'
  contentFlex?: 'fixed' | 'grow' | 'shrink' | 'growShrink'
  childrenFlexDirection?: 'row' | 'column'
  headingMt?: TShirtSize
  extendedHeading?: ReactElement
  pyramidsMonthSelectionInfo?: string
  headingClassName?: string
}

export const InfoBoxTile: FC<PerInfoBoxTileProps> = ({
  heading,
  headingColor,
  headingAlign = 'left',
  contentAlign = 'start',
  contentFlex = 'growShrink',
  headingMt = 'none',
  childrenFlexDirection = 'row',
  extendedHeading,
  pyramidsMonthSelectionInfo,
  headingClassName,
  children,
}) => {
  const modifiers: string[] = []

  if (contentFlex) {
    modifiers.push(`per-flexRow--${contentFlex}`)
  }

  return (
    <PerFlexRow className={'fullHeight ' + modifiers.join(' ')} direction="column" justify="space-between">
      {!extendedHeading && (
        <PerText
          appearance="tile-heading"
          color={headingColor}
          align={headingAlign}
          mb="xxs"
          mt={headingMt}
          className={headingClassName && headingClassName}
        >
          {heading}
        </PerText>
      )}
      {pyramidsMonthSelectionInfo && (
        <PerText appearance="flowing-text" fontWeight="bold" mb="xxs">
          {pyramidsMonthSelectionInfo}
        </PerText>
      )}
      {!!extendedHeading && <PerFlexRow noWrap>{extendedHeading}</PerFlexRow>}
      <PerFlexRow align="middle" justify={contentAlign} className="fullHeight" noWrap direction={childrenFlexDirection}>
        {children}
      </PerFlexRow>
    </PerFlexRow>
  )
}
